import { gql } from 'apollo-boost'

const SAVE_DISH_REVIEW_TASK = gql`
  mutation saveDishReviewTask(
    $id: ID!
    $menuId: ID!
    $menuTitlesData: [SaveDishReviewTaskMenuTitleInput!]!
    $uploadedMenuTitlesData: [SaveDishReviewTaskUploadedMenuTitleInput!]
    $uploadedDishesData: [SaveDishReviewTaskUploadedDishInput!]
  ) {
    saveDishReviewTask(
      id: $id
      menuId: $menuId
      menuTitlesData: $menuTitlesData
      uploadedMenuTitlesData: $uploadedMenuTitlesData
      uploadedDishesData: $uploadedDishesData
    ) {
      id
    }
  }
`

export default SAVE_DISH_REVIEW_TASK
